// tslint:disable: no-unbound-method
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { CookieService } from "ngx-cookie";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

import { ConfigureService } from "../../../../../configure/configure.service";
import { AbstractService } from "../../../../../shared/abstract.service";
import { GenericService } from "../../../../../shared/generic.service";

import { User } from "../../../../../shared/model/api/user";
import { Booking } from "../../../../../shared/model/booking";
import { DiscountData } from "../../../../../shared/model/discountData";

@Injectable()
export class PaymentFormService extends AbstractService {
    constructor(
        private readonly http: HttpClient,
        private readonly config: ConfigureService,
        private readonly genericService: GenericService,
        protected cookieService: CookieService
    ) {
        super(cookieService);
    }

    createBooking(body): Observable<{ data: Booking }> {
        return this.http
            .post(
                `${this.config.params.apiClientUri}/v2/bookings`,
                body,
                this.addAuthHeaders()
            )
            .pipe(catchError(this.genericService.handleErrorCollection));
    }

    createBookingAsGuest(body): Observable<{ data: Booking }> {
        return this.http
            .post(`${this.config.params.apiClientUri}/v2/bookings`, body)
            .pipe(catchError(this.genericService.handleErrorCollection));
    }

    getPromoCodeForSlot(
        code: string,
        slotId: number,
        user?: User,
        guestEmail?: string
    ): Observable<DiscountData> {
        return this.http
            .get(
                `${
                    this.config.params.apiClientUri
                }/promo-codes/${code}/slots/${slotId}${
                    guestEmail ? `?email=${guestEmail}` : ""
                }`,
                !!user ? this.addAuthHeaders() : undefined
            )
            .pipe(catchError(this.genericService.handleErrorCollection));
    }
}
